import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Typography } from '@material-ui/core'

const useStyles = makeStyles(({
  date: {
    textAlign: 'right'
  }
}))

export const SubTitle = (props) => {
  const classes = useStyles()
  return (
    <Grid container>
      <Grid item xs={12} className={classes.date}>
        <Typography variant='body1'>
          {props.post.getYmdDate()}
        </Typography>
      </Grid>
    </Grid>
  )
}
